
// console.log('My Wishlist page');

// const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
// const LOCAL_STORAGE_DELIMITER = ',';
// const BUTTON_ACTIVE_CLASS = 'active';
// const GRID_LOADED_CLASS = 'loaded';

// const selectors = {
//   button: '[button-wishlist]',
//   grid: '[grid-wishlist]',
//   productCard: '.product-card',
// };

// document.addEventListener('DOMContentLoaded', () => {
//   initButtons();
//   initGrid();
// });

// document.addEventListener('shopify-wishlist:updated', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
//   initGrid();
// });

// document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
// });

// document.addEventListener('shopify-wishlist:init-buttons', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
// });

// const fetchProductCardHTML = (handle) => {
//   const productTileTemplateUrl = `/products/${handle}?view=card`;
//   return fetch(productTileTemplateUrl)
//   .then((res) => res.text())
//   .then((res) => {
//     const text = res;
//     const parser = new DOMParser();
//     const htmlDocument = parser.parseFromString(text, 'text/html');
//     const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
//     return productCard.outerHTML;
//   })
//   .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
// };

// const setupGrid = async (grid) => {
//   const wishlist = getWishlist();
//   const requests = wishlist.map(fetchProductCardHTML);
//   const responses = await Promise.all(requests);
//   const wishlistProductCards = responses.join('');
//   grid.innerHTML = wishlistProductCards;
//   grid.classList.add(GRID_LOADED_CLASS);
//   initButtons();

//   // My counter goes here
//   // Update the counter span with the number of items in the wishlist
//   const counterSpan = document.getElementById('wishlistCounter');
//   if (counterSpan) {
//     counterSpan.textContent = wishlist.length.toString();
//   }
//   // End of the counter

//   const event = new CustomEvent('shopify-wishlist:init-product-grid', {
//     detail: { wishlist: wishlist }
//   });
//   document.dispatchEvent(event);
// };

// const setupButtons = (buttons) => {
//   buttons.forEach((button) => {
//     const productHandle = button.dataset.productHandle || false;
//     if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
//     if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
//     button.addEventListener('click', () => {
//       updateWishlist(productHandle);
//       button.classList.toggle(BUTTON_ACTIVE_CLASS);
//     });
//   });
// };

// const initGrid = () => {
//   const grid = document.querySelector(selectors.grid) || false;
//   if (grid) setupGrid(grid);
// };

// const initButtons = () => {
//   const buttons = document.querySelectorAll(selectors.button) || [];
//   if (buttons.length) setupButtons(buttons);
//   else return;
//   const event = new CustomEvent('shopify-wishlist:init-buttons', {
//     detail: { wishlist: getWishlist() }
//   });
//   document.dispatchEvent(event);
// };

// const getWishlist = () => {
//   const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
//   if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
//   return [];
// };

// const setWishlist = (array) => {
//   const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
//   if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
//   else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

//   const event = new CustomEvent('shopify-wishlist:updated', {
//     detail: { wishlist: array }
//   });
//   document.dispatchEvent(event);

//   return wishlist;
// };

// const updateWishlist = (handle) => {
//   const wishlist = getWishlist();
//   const indexInWishlist = wishlist.indexOf(handle);
//   if (indexInWishlist === -1) wishlist.push(handle);
//   else wishlist.splice(indexInWishlist, 1);
//   return setWishlist(wishlist);
// };

// const wishlistContains = (handle) => {
//   const wishlist = getWishlist();
//   return wishlist.includes(handle);
// };

// const resetWishlist = () => {
//   return setWishlist([]);
// };

// console.log('My Wishlist page');

// const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
// const LOCAL_STORAGE_DELIMITER = ',';
// const BUTTON_ACTIVE_CLASS = 'active';
// const GRID_LOADED_CLASS = 'loaded';

// const selectors = {
//   button: '[button-wishlist]',
//   grid: '[grid-wishlist]',
//   productCard: '.product-card',
// };

// document.addEventListener('DOMContentLoaded', () => {
//   initButtons();
//   initGrid();
//   toggleEmptyMessageVisibility(); // Call to toggle the visibility initially
// });

// document.addEventListener('shopify-wishlist:updated', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
//   initGrid();
//   toggleEmptyMessageVisibility(); // Call to toggle the visibility when the wishlist is updated
// });

// document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
// });

// document.addEventListener('shopify-wishlist:init-buttons', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
// });

// const fetchProductCardHTML = (handle) => {
//   const productTileTemplateUrl = `/products/${handle}?view=card`;
//   return fetch(productTileTemplateUrl)
//     .then((res) => res.text())
//     .then((res) => {
//       const text = res;
//       const parser = new DOMParser();
//       const htmlDocument = parser.parseFromString(text, 'text/html');
//       const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
//       return productCard.outerHTML;
//     })
//     .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
// };

// const setupGrid = async (grid) => {
//   const wishlist = getWishlist();
//   const requests = wishlist.map(fetchProductCardHTML);
//   const responses = await Promise.all(requests);
//   const wishlistProductCards = responses.join('');
//   grid.innerHTML = wishlistProductCards;
//   grid.classList.add(GRID_LOADED_CLASS);
//   initButtons();
//   toggleEmptyMessageVisibility(); // Call to toggle the visibility after updating the grid

//   const event = new CustomEvent('shopify-wishlist:init-product-grid', {
//     detail: { wishlist: wishlist }
//   });
//   document.dispatchEvent(event);
// };



// const setupButtons = (buttons) => {
//   buttons.forEach((button) => {
//     const productHandle = button.dataset.productHandle || false;
//     if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
//     if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
//     button.addEventListener('click', () => {
//       updateWishlist(productHandle);
//       button.classList.toggle(BUTTON_ACTIVE_CLASS);
//       toggleEmptyMessageVisibility(); // Call to toggle the visibility after updating the wishlist
//     });
//   });
// };

// const initGrid = () => {
//   const grid = document.querySelector(selectors.grid) || false;
//   if (grid) setupGrid(grid);
// };

// const initButtons = () => {
//   const buttons = document.querySelectorAll(selectors.button) || [];
//   if (buttons.length) setupButtons(buttons);
//   else return;
//   const event = new CustomEvent('shopify-wishlist:init-buttons', {
//     detail: { wishlist: getWishlist() }
//   });
//   document.dispatchEvent(event);
// };

// const getWishlist = () => {
//   const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
//   if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
//   return [];
// };

// const setWishlist = (array) => {
//   const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
//   if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
//   else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

//   const event = new CustomEvent('shopify-wishlist:updated', {
//     detail: { wishlist: array }
//   });
//   document.dispatchEvent(event);

//   return wishlist;
// };

// const updateWishlist = (handle) => {
//   const wishlist = getWishlist();
//   const indexInWishlist = wishlist.indexOf(handle);
//   if (indexInWishlist === -1) wishlist.push(handle);
//   else wishlist.splice(indexInWishlist, 1);
//   return setWishlist(wishlist);
// };

// const wishlistContains = (handle) => {
//   const wishlist = getWishlist();
//   return wishlist.includes(handle);
// };

// const resetWishlist = () => {
//   return setWishlist([]);
// };

// const toggleEmptyMessageVisibility = () => {
//   const emptyWishlistMessage = document.querySelector('.empty-wishlist-message');
//   const wishlistGrid = document.querySelector('.wishlist__grid');
//   if (wishlistGrid.children.length === 0) {
//     emptyWishlistMessage.style.display = 'block';
//     // Add a class to trigger the fade-in animation
// emptyWishlistMessage.classList.add('fade-in');

//   } else {
//     emptyWishlistMessage.style.display = 'none';
//   }
// };


console.log('My Wishlist page');

const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

const updateWishlistCounter = () => {
  const wishlistCounter = document.getElementById('wishlistCounter');
  if (!wishlistCounter) return;
  wishlistCounter.textContent = getWishlist().length;
};

const initRemoveButtons = (container) => {
  const scope = container || document;
  scope.querySelectorAll('[button-wishlist-remove]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.productHandle;
      if (handle) updateWishlist(handle);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  initRemoveButtons();
  toggleEmptyMessageVisibility();
  updateWishlistCounter();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  initGrid();
  toggleEmptyMessageVisibility();
  updateWishlistCounter();

  const added = event.detail.added;
  const source = document.querySelector('#wishlist-notification[data-added]');
  const addedText = source ? source.dataset.added : '';
  const removedText = source ? source.dataset.removed : '';
  const linkText = source ? source.dataset.linkText : '';

  document.querySelectorAll('#wishlist-notification, #wishlist-notification-larger').forEach((notification) => {
    if (added) {
      notification.textContent = addedText;
      notification.innerHTML += ` &nbsp; <a class="wishlist-notification-link" href="/pages/wishlist">${linkText}</a>`;
    } else {
      notification.textContent = removedText;
    }
    notification.classList.add('show');
    setTimeout(() => { notification.classList.remove('show'); }, 3000);
  });
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    })
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();
  initRemoveButtons(grid);
  toggleEmptyMessageVisibility();
  updateWishlistCounter();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    if (button.dataset.wishlistBound) return;
    button.dataset.wishlistBound = '1';
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      toggleEmptyMessageVisibility();
      updateWishlistCounter();
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array, handle = null, added = null) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array, handle, added }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  const added = indexInWishlist === -1;
  if (added) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist, handle, added);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const toggleEmptyMessageVisibility = () => {
  const emptyWishlistMessage = document.querySelector('.empty-wishlist-message');
  const wishlistGrid = document.querySelector('.wishlist__grid');
  if (!wishlistGrid || !emptyWishlistMessage) return;
  if (wishlistGrid.children.length === 0) {
    emptyWishlistMessage.style.display = 'block';
    emptyWishlistMessage.classList.add('fade-in');
  } else {
    emptyWishlistMessage.style.display = 'none';
  }
};
